
import { defineComponent } from "vue";
import ImageLoader from "../UI/ImageLoader.vue";

export default defineComponent({
  name: "Monkey",
  components: {
    ImageLoader,
  },

  props: {
    monkey: {
      type: Object,
      required: true,
    },
    monkeyHealth: {
      type: Number,
      required: true,
    },
    healthTop: {
      type: Boolean,
      required: false,
    },
    turn: {
      type: Boolean,
      required: false,
    },
  },
});
